import React from 'react'
import {
  // Button,
  FormDashboardTextarea as Textarea,
  FormDashboardInput as Input,
  FormDashboardLabel as Label,
  ImagePickerSidebar,
  FormRow,
} from '../../../components'

const ProgramProfile = () => {
  return (
    <div>
      <p className="text-lg font-bold mb-5 lg:mb-8">Profile</p>
      <FormRow>
        <Label>Title (English)</Label>
        <Input className="w-full" defaultValue="Frosh by Peacegen"/>
      </FormRow>
      <FormRow>
        <Label>Title (Indonesia)</Label>
        <Input className="w-full" defaultValue="Frosh oleh Peacegen"/>
      </FormRow>
      <FormRow>
        <ImagePickerSidebar label="Image" height="200px" buttonWidth="160px" message="JPG, GIF or PNG no larger than 1MB."/>
      </FormRow>
      <FormRow>
        <Label>About (English version)</Label>
        <Textarea
          className="w-full"
          rows={10}
          defaultValue={
            `Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet.

            Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud ollit non deserunt ullamco est sit aliqua dolor do amet sint. `
          }
        />
      </FormRow>
      <FormRow>
        <Label>About (Indonesia version)</Label>
        <Textarea
          className="w-full"
          rows={10}
          defaultValue={
            `Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet.

            Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud ollit non deserunt ullamco est sit aliqua dolor do amet sint. `
          }
        />
      </FormRow>
    </div>
  )
}

export { ProgramProfile }
